// Domain
import { ContractStatesEnumeration } from '../enumerations/contract-states.enumeration';

const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.contractContainer.contractFlowsConfiguration.';

const AT_THE_TIME_OF_SHIPPING = `${DOMAIN}atTheTimeOfShipping`,
  CONTRACT_DESCRIPTIONS = {
    [ContractStatesEnumeration.PRECONTRACTUAL]: `${DOMAIN}precontractualDescription`,
  },
  CONTRACT_TITLES = {
    [ContractStatesEnumeration.PRECONTRACTUAL]: `${DOMAIN}precontractualTitle`,
    [ContractStatesEnumeration.CONTRACTUAL]: `${DOMAIN}contractualTitle`,
    [ContractStatesEnumeration.OTP]: `${DOMAIN}otpTitle`,
  },
  EVERY_MONTH = `${DOMAIN}everyMonth`,
  INTEREST = `${DOMAIN}interest`,
  PAYMENT_METHOD = `${DOMAIN}paymentMethod`,
  TOTAL_BASKET_AMOUNT = `${DOMAIN}totalBasketAmount`,
  TOTAL_AMOUNT = `${DOMAIN}totalAmount`;

export { 
  AT_THE_TIME_OF_SHIPPING,
  CONTRACT_DESCRIPTIONS, 
  CONTRACT_TITLES,
  EVERY_MONTH,
  INTEREST,
  PAYMENT_METHOD,
  TOTAL_AMOUNT,
  TOTAL_BASKET_AMOUNT
};